import { render, staticRenderFns } from "./TransitionCollapseHeight.vue?vue&type=template&id=4d2c56fe&scoped=true&"
import script from "./TransitionCollapseHeight.vue?vue&type=script&lang=js&"
export * from "./TransitionCollapseHeight.vue?vue&type=script&lang=js&"
import style0 from "./TransitionCollapseHeight.vue?vue&type=style&index=0&id=4d2c56fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c56fe",
  null
  
)

export default component.exports